import { combineReducers } from 'redux';
import mobileNavigationReducers from './navigations';
import companiesReducers from './companies';


export default combineReducers({
  mobileNavigationReducers,
  companiesReducers
});
